import React, {Component} from 'react';
import {MainContext} from "contexts/main.context";
import SubHeader from "components/helpers/subHeader/subHeader";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import {Button, Typography} from "@material-ui/core";
import PedidosService from "services/pedidos.service";
import {HojasDeRutaService} from "services";
import {withSnackbar} from "notistack";
import {RemitoUploader} from "./remito.uploader";

export class EntregasEntregar extends Component {
  HojasDeRutaService = new HojasDeRutaService(this.context);
  PedidosService = new PedidosService(this.context);

  state = {
    recibo: false
  };

  entregarPedido = () => this.PedidosService.changeStatus(
    this.props.match.params.pedido,
    'E',
    success => {
      this.props.enqueueSnackbar(`Se marcó el pedido ${this.props.match.params.pedido} como entregado`, {variant: 'success'});
      this.props.history.goBack();
      this.props.history.goBack();
    },
    error => this.props.enqueueSnackbar(error, {variant: 'error'})
  );

  render() {
    const {recibo} = this.state;
    return (
      <div>
        <SubHeader
          title={'Entregas'}
        />
        <Box className={'m-4'}>
          <Grid container direction={"column"} spacing={3}>
            <Grid item>
              <Typography variant={"h6"} className={'font-weight-normal'} align={"center"}>
                Entregar pedido completo
              </Typography>
              <Typography variant={"body1"} color={"textSecondary"} className={'font-weight-normal mt-2'} align={"center"}>
                Para confirmar la entrega suba una foto del remito
              </Typography>
            </Grid>
            <Grid item className={'text-center'}>
              <RemitoUploader
                idPedido={this.props.match.params.pedido}
                idEntrega={this.props.match.params.entrega}
                recibo={recibo}
                onUpload={() => this.setState({recibo: true})}
              />
            </Grid>
            <Grid item>
              <Button
                variant={"contained"}
                color={"primary"}
                className={'w-100'}
                style={{height: '3.5rem'}}
                disabled={!recibo}
                onClick={this.entregarPedido}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    )
  }
}

EntregasEntregar.contextType = MainContext;
EntregasEntregar = withSnackbar(EntregasEntregar);
